// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pizBf6ZJqAHneF48OFBx{display:flex;background-color:rgba(255,255,255,0);margin-top:100px}", "",{"version":3,"sources":["webpack://./src/components/Page/Footer.module.scss"],"names":[],"mappings":"AAAA,sBAEI,YAAA,CACA,oCAAA,CACA,gBAAA","sourcesContent":[".Footer {\n    \n    display: flex;\n    background-color: rgba(255, 255, 255, 0);\n    margin-top: 100px;\n\n\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Footer": "pizBf6ZJqAHneF48OFBx"
};
export default ___CSS_LOADER_EXPORT___;
